export default __webpack_public_path__ + "static/media/PowderAdhesionImg.364117c2.jpg";